<template>
  <div class="form-group text-center">
    <label class="form-control-label" :for="'input-text-' + this._uid">
      <slot></slot> <span v-if="required" class="required" data-toggle="tooltip" data-placement="bottom" title="Required">*</span>
    </label>
    <br>
    <div class="switch">
      <i v-if="value === true" class="fa fa-toggle-on" aria-hidden="true" @click="updateValue(false)"></i>
      <i v-else class="fa fa-toggle-off c5" aria-hidden="true" @click="updateValue(true)"></i>
    </div>
    <small v-if="helpText" class="form-text text-muted">{{helpText}}</small>
    <div v-if="error" class="invalid-feedback">{{ error.message }}</div>
  </div>
</template>
<script>
export default {
  name: "vue-ez-toggle",
  props: ["value", "disabled", "required", "helpText", "error"],
  methods: {
    updateValue(value) {
      this.$emit("input", value);
    }
  }
};
</script>

<style lang="scss" scooped>
.switch {
  cursor: pointer;
  font-size: 1.5em;
}
</style>
